/* eslint-disable import/prefer-default-export */
import { selectRootSlicePlatform } from '../../Main/selectors';
import { ROOT_SLICE } from './constants';

export const selectRootSlice = state => {
	const slice = selectRootSlicePlatform(state);
	return slice[ROOT_SLICE];
};

export const selectMessages = state => {
	const slice = selectRootSlice(state);
	const { messages } = slice;
	return messages;
};

export const selectIsLoadingMessages = state => {
	const slice = selectRootSlice(state);
	const { isLoadingMessages } = slice;
	return isLoadingMessages;
};

export const selectIsLoadedMessages = state => {
	const slice = selectRootSlice(state);
	const { isLoadedMessages } = slice;
	return isLoadedMessages;
};

export const selectHasLoadingError = state => {
	const slice = selectRootSlice(state);
	const { hasLoadingError } = slice;
	return hasLoadingError;
};
